import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_get_printersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { letterOnly?: boolean, fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { name?: string, id?: number, state?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_printers/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { letterOnly?: boolean, fullTextSearch?: string, $keys: number[] }): Promise<{ result?: { name?: string, id?: number, state?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_printers/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      letterOnly?: boolean, fullTextSearch?: string    }) {
      return false;
    }
}
